var map = {
	"./airdrop.vue": 69796,
	"./arena.vue": 43594,
	"./assets.vue": 33557,
	"./battle.vue": 50839,
	"./battleRecord.vue": 25795,
	"./battleTest.vue": 5342,
	"./detail.vue": 71932,
	"./diamond.vue": 17128,
	"./friend.vue": 45311,
	"./index.vue": 55583,
	"./mining.vue": 79831,
	"./rank.vue": 58314,
	"./shop.vue": 57251,
	"./task.vue": 12937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;